import { render } from "./AdminDeviceList.vue?vue&type=template&id=201f232a"
import script from "./AdminDeviceList.vue?vue&type=script&lang=js"
export * from "./AdminDeviceList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__